import { Link } from 'react-router-dom';
import { BRAND } from '@/config/brand';

const EFFECTIVE_DATE = 'August 4, 2026';

export function formatAddress() {
  const { line1, city, state, zip } = BRAND.address;
  return `${line1}, ${city}, ${state} ${zip}`;
}

export default function LegalPageLayout({ title, children }) {
  return (
    <div>
      <section className="relative hero-gradient noise-overlay">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center sm:py-20">
          <p className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-white/80">
            {BRAND.legalName}
          </p>
          <h1 className="font-display mx-auto mt-4 max-w-3xl text-3xl font-bold text-white sm:text-4xl">
            {title}
          </h1>
          <p className="mx-auto mt-3 text-sm text-white/80">Effective date: {EFFECTIVE_DATE}</p>
        </div>
      </section>

      <article className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
        <div className="space-y-10 text-slate-600 leading-relaxed [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-slate-900 [&_h2]:sm:text-2xl [&_h3]:mt-4 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-slate-800 [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pl-5 [&_ol]:mt-3 [&_ol]:list-decimal [&_ol]:space-y-2 [&_ol]:pl-5 [&_p]:mt-3 [&_a]:text-blue-700 [&_a]:underline [&_a]:underline-offset-2 hover:[&_a]:text-blue-800 [&_table]:mt-4 [&_table]:w-full [&_table]:text-left [&_table]:text-sm [&_th]:border-b [&_th]:border-slate-200 [&_th]:py-2 [&_th]:pr-4 [&_th]:font-semibold [&_th]:text-slate-900 [&_td]:border-b [&_td]:border-slate-100 [&_td]:py-2 [&_td]:pr-4 [&_td]:align-top">
          {children}
        </div>

        <aside className="mt-12 rounded-xl border border-slate-200 bg-slate-50 p-5 text-sm text-slate-600">
          <p className="font-semibold text-slate-900">Contact</p>
          <p className="mt-2">{BRAND.legalName}</p>
          <p>{formatAddress()}</p>
          <p className="mt-2">
            <a href={`mailto:${BRAND.support.email}`} className="text-blue-700 underline underline-offset-2 hover:text-blue-800">
              {BRAND.support.email}
            </a>
            {' · '}
            <Link to="/contact" className="text-blue-700 underline underline-offset-2 hover:text-blue-800">
              Contact form
            </Link>
          </p>
        </aside>
      </article>
    </div>
  );
}
